import type { GuestSummaryDto } from '../../api/types';

/** Farbe des Zustands-Badges — gleiche Ampel-Semantik auf allen Gast-Seiten. */
export type BadgeColor = 'success' | 'warning' | 'danger' | 'severe' | 'informative';

export function stateColor(state: string): BadgeColor {
  switch (state) {
    case 'Aktiv':
      return 'success';
    case 'Ausstehend':
      return 'warning';
    case 'Abgelaufen':
      return 'severe';
    case 'Gesperrt':
    case 'Widerrufen':
      return 'danger';
    default:
      return 'informative';
  }
}

/** Datum ohne Uhrzeit (dd.MM.yyyy); leere Werte werden als „—" dargestellt. */
export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString('de-DE');
}

/** Datum mit Uhrzeit (dd.MM.yyyy, HH:mm) — für die letzte Anmeldung. */
export function formatDateTime(iso?: string | null): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? '—'
    : `${d.toLocaleDateString('de-DE')}, ${d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}`;
}

/** „Gültig bis" inkl. Restlaufzeit, z. B. „31.12.2026 (noch 12 T)". */
export function formatValidity(guest: GuestSummaryDto): string {
  if (!guest.validUntilUtc) return 'unbefristet';
  const date = formatDate(guest.validUntilUtc);
  return guest.daysRemaining == null ? date : `${date} (noch ${guest.daysRemaining} T)`;
}

/** Datumswert für ein `<input type="date">` (YYYY-MM-DD) aus einem ISO-Zeitstempel. */
export function toDateInput(iso?: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toISOString().slice(0, 10);
}

/** Datum in `tage` Tagen als Wert für ein `<input type="date">`. */
export function dateInputInDays(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

/**
 * Tage seit der letzten Anmeldung. `null` bedeutet „nie angemeldet" (oder die
 * Anmelde-Aktivität war nicht lesbar) — das ist bewusst von „0 Tage" getrennt.
 */
export function daysSinceSignIn(iso?: string | null): number | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Math.floor((Date.now() - d.getTime()) / 86_400_000);
}
